import { gql } from 'graphql-request';
import { useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import { EventData } from '../event/event-types';
import { EventContainer } from '../events/helpers/fetch-events';

export const GET_EVENT_QUERY = gql`
    query GetEvent($key: String!) {
        event: resource(key: $key) {
            content
            key
        }
    }
`;

export const GET_RELATED_EVENTS = gql`
    query GetRelatedEvents(
        $tags: [String]
    ) {
        relatedEvents: resources(
            type: "event"
            tags: $tags
        ) {
            content
        }
    }
`;

export const fetchEvent = (slug: string) => {    
    const { createCachedResource } = useContext(AppContext);
    const [eventContent] = createCachedResource(
        GET_EVENT_QUERY,
        () => ({ key: `/event/${slug}` }),
        true
    );

    return eventContent()?.event?.content;
};

export const fetchRelatedEvents = (tags: string[] | undefined, currentEventId: number | undefined): EventData[] => {
    const { createCachedResource } = useContext(AppContext);
    const [relatedEvents] = createCachedResource(
        GET_RELATED_EVENTS,
        () => ({ tags }),
        true
    );
    
    return relatedEvents()?.relatedEvents
        ?.filter((event: EventContainer) => {
            return event.content.id !== currentEventId;
        })
        ?.filter((event: EventContainer) => {
            return new Date(event.content.date).getTime() >= new Date().getTime();
        });
};
